import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {finalize} from "rxjs/operators";
import {PdfJsViewerComponent} from "ng2-pdfjs-viewer";

@Component({
  selector: 'ngx-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnInit {

  @ViewChild('pdfViewer', { static: false }) pdfViewer: PdfJsViewerComponent;
  @Input()billPDF;
  @Input()pdfFailed;
  @Input()pdfAbsent=false;
  docLoaded: boolean;
  url: string;
  error: any;
  id: number;
  encodeURIComponent = encodeURIComponent;
  constructor() {
    this.url = this.billPDF;
  }

  ngOnInit() {
  }
  ionViewDidEnter() {
  }
  ionViewWillEnter() {
    this.docLoaded = false;
  }
  handleError(err) {
    console.log(err);
    this.error = err;
  }
  onDocumentLoad() {
    this.docLoaded = true;
    (this.pdfViewer.iframe.nativeElement as HTMLIFrameElement).style.border = '0';
    this.pdfViewer.refresh();
  }

}
